module.exports = __webpack_public_path__ + "static/media/เถาะ.5e264509.png";